import { createAction } from '@reduxjs/toolkit';
import { SERIALIZE_QUERY, POST_PROCESSING_FINISHED, SET_QUERY, SELECT_EVENT_COLLECTION, SELECT_ANALYSIS, SELECT_TARGET_PROPERTY, SET_PERCENTILE, SET_TIMEFRAME, SET_GROUP_BY, SET_ORDER_BY, SET_PROPERTY_NAMES, SET_LIMIT, SET_INTERVAL, SET_EXTRACTION_LIMIT, SET_FILTERS, SELECT_TIMEZONE, ADD_FUNNEL_STEP, CLONE_FUNNEL_STEP, SELECT_FUNNEL_STEP_EVENT_COLLECTION, UPDATE_FUNNEL_STEP, REMOVE_FUNNEL_STEP, SET_FUNNEL_STEPS, SET_FUNNEL_STEP_FILTERS, CHANGE_FUNNEL_STEPS_ORDER, ADD_FUNNEL_STEP_FILTER, UPDATE_FUNNEL_STEP_FILTER, REMOVE_FUNNEL_STEP_FILTER, RESET_EXTRACTION, RESET_QUERY, ADD_FILTER, UPDATE_FILTER, REMOVE_FILTER, UPDATE_FUNNEL_STEP_TIMEZONE } from './constants';
export var setQuery = function setQuery(query) {
  return {
    type: SET_QUERY,
    payload: {
      query: query
    }
  };
};
export var serializeQuery = function serializeQuery(query) {
  return {
    type: SERIALIZE_QUERY,
    payload: {
      query: query
    }
  };
};
export var postProcessingFinished = function postProcessingFinished() {
  return {
    type: POST_PROCESSING_FINISHED
  };
};
export var resetQuery = function resetQuery(defaultTimezoneForQuery) {
  return {
    type: RESET_QUERY,
    payload: {
      defaultTimezoneForQuery: defaultTimezoneForQuery
    }
  };
};
export var addFilter = function addFilter(id) {
  return {
    type: ADD_FILTER,
    payload: {
      id: id
    }
  };
};
export var removeFilter = function removeFilter(id) {
  return {
    type: REMOVE_FILTER,
    payload: {
      id: id
    }
  };
};
export var updateFilter = function updateFilter(id, filter) {
  return {
    type: UPDATE_FILTER,
    payload: {
      id: id,
      filter: filter
    }
  };
};
export var setPropertyNames = function setPropertyNames(propertyNames) {
  return {
    type: SET_PROPERTY_NAMES,
    payload: {
      propertyNames: propertyNames
    }
  };
};
export var selectEventCollection = function selectEventCollection(name) {
  return {
    type: SELECT_EVENT_COLLECTION,
    payload: {
      name: name
    }
  };
};
export var selectAnalysis = function selectAnalysis(analysis) {
  return {
    type: SELECT_ANALYSIS,
    payload: {
      analysis: analysis
    }
  };
};
export var selectTargetProperty = function selectTargetProperty(property) {
  return {
    type: SELECT_TARGET_PROPERTY,
    payload: {
      property: property
    }
  };
};
export var selectTimezone = createAction(SELECT_TIMEZONE, function (timezone) {
  return {
    payload: {
      timezone: timezone
    }
  };
});
export var setInterval = function setInterval(interval) {
  return {
    type: SET_INTERVAL,
    payload: {
      interval: interval
    }
  };
};
export var setPercentile = function setPercentile(percentile) {
  return {
    type: SET_PERCENTILE,
    payload: {
      percentile: percentile
    }
  };
};
export var setGroupBy = function setGroupBy(groupBy) {
  return {
    type: SET_GROUP_BY,
    payload: {
      groupBy: groupBy
    }
  };
};
export var setOrderBy = function setOrderBy(orderBy) {
  return {
    type: SET_ORDER_BY,
    payload: {
      orderBy: orderBy
    }
  };
};
export var setLimit = function setLimit(limit) {
  return {
    type: SET_LIMIT,
    payload: {
      limit: limit
    }
  };
};
export var setExtractionLimit = function setExtractionLimit(limit) {
  return {
    type: SET_EXTRACTION_LIMIT,
    payload: {
      limit: limit
    }
  };
};
export var resetExtraction = function resetExtraction() {
  return {
    type: RESET_EXTRACTION
  };
};
export var setTimeframe = function setTimeframe(timeframe) {
  return {
    type: SET_TIMEFRAME,
    payload: {
      timeframe: timeframe
    }
  };
};
export var setFilters = function setFilters(filters) {
  return {
    type: SET_FILTERS,
    payload: {
      filters: filters
    }
  };
};
export var addFunnelStep = function addFunnelStep(id, defaultTimezone) {
  return {
    type: ADD_FUNNEL_STEP,
    payload: {
      id: id,
      defaultTimezone: defaultTimezone
    }
  };
};
export var cloneFunnelStep = function cloneFunnelStep(cloneId, newId) {
  return {
    type: CLONE_FUNNEL_STEP,
    payload: {
      cloneId: cloneId,
      newId: newId
    }
  };
};
export var selectFunnelStepCollection = function selectFunnelStepCollection(name) {
  return {
    type: SELECT_FUNNEL_STEP_EVENT_COLLECTION,
    payload: {
      name: name
    }
  };
};
export var updateFunnelStep = function updateFunnelStep(stepId, properties) {
  return {
    type: UPDATE_FUNNEL_STEP,
    payload: {
      stepId: stepId,
      properties: properties
    }
  };
};
export var changeFunnelStepsOrder = function changeFunnelStepsOrder(steps) {
  return {
    type: CHANGE_FUNNEL_STEPS_ORDER,
    payload: {
      steps: steps
    }
  };
};
export var setFunnelSteps = function setFunnelSteps(steps) {
  return {
    type: SET_FUNNEL_STEPS,
    payload: {
      steps: steps
    }
  };
};
export var setFunnelStepFilters = function setFunnelStepFilters(stepId, filters) {
  return {
    type: SET_FUNNEL_STEP_FILTERS,
    payload: {
      stepId: stepId,
      filters: filters
    }
  };
};
export var removeFunnelStep = function removeFunnelStep(stepId) {
  return {
    type: REMOVE_FUNNEL_STEP,
    payload: {
      stepId: stepId
    }
  };
};
export var addFunnelStepFilter = function addFunnelStepFilter(stepId, filterId) {
  return {
    type: ADD_FUNNEL_STEP_FILTER,
    payload: {
      stepId: stepId,
      filterId: filterId
    }
  };
};
export var updateFunnelStepFilter = function updateFunnelStepFilter(stepId, filterId, properties) {
  return {
    type: UPDATE_FUNNEL_STEP_FILTER,
    payload: {
      stepId: stepId,
      filterId: filterId,
      properties: properties
    }
  };
};
export var removeFunnelStepFilter = function removeFunnelStepFilter(stepId, filterId) {
  return {
    type: REMOVE_FUNNEL_STEP_FILTER,
    payload: {
      stepId: stepId,
      filterId: filterId
    }
  };
};
export var updateFunnelStepTimezone = createAction(UPDATE_FUNNEL_STEP_TIMEZONE, function (stepId, timezone) {
  return {
    payload: {
      stepId: stepId,
      timezone: timezone
    }
  };
});